import type { RootState } from '../RootState';

export const selectSession = (s: RootState) => s.session;
export const selectCurrentWorkspaceId = (s: RootState) => s.session.currentWorkspaceId;
export const selectLang = (s: RootState) => s.session.lang;
